import { TablePagination } from "@material-ui/core";
import React, { Component } from "react";
import Column from "./Column";
import InlineRow from "./InlineRow";
import { getJsDateFromExcel } from "excel-date-to-js";
import { getDateByFormat } from "../../bae-client/Utils";
import { getParsedDateByDateAndTime } from "../../bae-client/Utils";
import "./Archive.css";
import PopoverViewCustom from "./PopoverViewCustom";
import ListView from "./ListView";
import CustomDropdown from "./CustomDropdown";
import CustomSearchDropdown from "./CustomDropDown/index";
class ArchiveListItems extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startCount: 0,
            lastCount: 10,
            page: 0,
            rowsPerPage: 100,
            selectedFilter: "",
        };
        this.rowData = [];
        this.filterItems = [
            {
                text: "Date",
                value: "date",
                id: "date_filter",
            },
            {
                text: "Type",
                value: "type",
                id: "type_filter",
            },
        ];
    }

    handleRestoreBtnClick = (rowItem, index) => {
        this.props.restoreBtnClicked(rowItem, index);
    };

    handleDateFilter = (index, listValue, listText, event) => {
        this.props.sortBtnClicked(listValue.value);
    };
    renderFilterDropdown = () => {
        return (
            // <div className="filterBtn ml-3">
            //     <PopoverViewCustom
            //         btnClass={"ctBtnFont"}
            //         iconClass="fas fa-angle-down" //btnLabel="Generic Blockchain Name"
            //         btnLabel={
            //             this.state.selectedFilter !== ""
            //                 ? this.state.selectedFilter
            //                 : "Sort By"
            //         }
            //         isDropdown={true}
            //     >
            //         <ListView
            //             className="noBorder"
            //             listItemClassname="pl-4"
            //             id={"GenericBlockchainName"}
            //             items={this.filterItems}
            //             showIcon="false"
            //             disableActiveIndex="true"
            //             onchange={this.handleDateFilter}
            //         />
            //     </PopoverViewCustom>
            // </div>
            <CustomSearchDropdown
                items={this.filterItems}
                label={"Sort By"}
                id={"sortBy"}
                multiSelect={false}
                isSearchable={true}
                isChipView={false}
                handleSelection={this.handleDateFilter}
                dropdownPosition={'archive'}
            ></CustomSearchDropdown>
        );
    };
    renderHeaderBar = () => {
        return (
            <InlineRow classname="doCenter archiveHeaderRow m-0">
                {/* <label className="headerLabel">Sort By</label> */}
                {this.renderFilterDropdown()}
                {/* 
                <button
                    onClick={this.props.restoreAllBtnClicked}
                    className="btn btnLabel doCenter newFontMontserrat restoreAll_btn"
                    style={{ width: "auto" }}
                >
                    RESTORE ALL
                </button> */}
                {/* <Column size="3">
                            <button className="btn btnLabel doCenter newFontMontserrat">
                                TYPE
                            </button>
                        </Column> */}
            </InlineRow>
        );
    };
    handlechangeCount = (value) => {};
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage });
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value, 10),
        });
    };
    renderPagination = () => {
        return (
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={this.rowData.length}
                page={this.state.page}
                onChangePage={this.handleChangePage}
                rowsPerPage={this.state.rowsPerPage}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
            />
        );
    };
    parseDateExcelToUTC = (dateValue) => {
        let strDate = "" + dateValue;
        let localDate = getJsDateFromExcel(dateValue).toLocaleDateString(
            "en-US",
            { timeZone: "UTC" }
        );
        //let time = getJsDateFromExcel(dateValue).toLocaleTimeString('en-US', { timeZone: 'UTC', timeSyle: "short" });
        //let temp = time.split(" ")[0].split(":");
        //temp = temp[0] + ":" + temp[1] + " " + time.split(" ")[1];
        //return localDate + " - " + temp;
        return localDate;
    };
    getImageIcon = (type) => {
        let source = null;
        switch (type) {
            case "Space":
                source = "./images/Space 2.svg";
                break;
            case "Folder":
                source = "./images/FOLDER.svg";
                break;
            case "File":
                source = "./images/basicfile.png";
                break;
            case "Alert":
                source = "./images/AlertIcon.svg";
                break;
            default:
                source = "./images/archive/file-zip.svg";
                break;
        }
        return source;
    };
    renderCardHeaderRow = () => {
        return (
            <div className="row m-0 w-100 archive_headerRow">
                <div className="col-5">
                    <div className="row p-0 m-0 w-100">
                        <div className="col-2"></div>
                        <div className="col-10">
                            <span className="archive_cardHeader_title">
                                Name
                            </span>
                        </div>
                    </div>
                </div>
                <div className="col-4 ml-4">
                    <span className="archive_cardHeader_title">Date Added</span>
                </div>
                <div className="col-3"></div>
            </div>
        );
    };
    renderTitle = (type, headerTitle) => {
        let title = "";
        if (headerTitle === "" || headerTitle === undefined) {
            title = "Unsaved";
        } else if (
            (type.toLowerCase() === "ripple" &&
                headerTitle.split(":")[0] === "") ||
            headerTitle.split(":")[0] === " "
        ) {
            title = "Unsaved : " + headerTitle.split(":")[1];
        } else {
            title = headerTitle;
        }
        return title;
    };
    renderCardRow = () => {
        // let rowData = this.props.rowItems;
        let rowsForLogs = [];
        this.rowData
            .slice(
                this.state.page * this.state.rowsPerPage,
                this.state.page * this.state.rowsPerPage +
                    this.state.rowsPerPage
            )
            .map((rowItem, index) => {
                // this.rowData.forEach((rowItem, index) => {
                let title = this.renderTitle(
                    rowItem.objectType,
                    rowItem.objectName
                );
                rowsForLogs.push(
                    <InlineRow
                        classname="rippleLogRow doCenter archiveItemRow"
                        noRow={true}
                    >
                        <Column size="5" className="p-0 textEllipsis">
                            <div
                                className="p-0 m-0 w-100"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                {/* <Column size="2" className="doCenter"> */}
                                <div
                                    className="doCenter"
                                    style={{ width: "3rem" }}
                                >
                                    <img
                                        alt="type"
                                        className={
                                            this.getImageIcon(
                                                rowItem.objectType
                                            ) === "./images/Workspace A.svg"
                                                ? "archiveAlertIcon mr-3 mainPageIconRadius"
                                                : "archiveAlertIcon mr-3"
                                        }
                                        src={this.getImageIcon(
                                            rowItem.objectType
                                        )}
                                    ></img>
                                </div>
                                {/* </Column>
                                <Column size="10" className="p-0"> */}
                                <label
                                    className="archiveRowTilalert m-0"
                                    title={title}
                                >
                                    {title}
                                </label>
                                {/* </Column> */}
                            </div>
                        </Column>
                        <Column size="4">
                            {rowItem.archivedDate !== "" ? (
                                <label className="archived_date m-0">
                                    {
                                        "Archived on " +
                                            getParsedDateByDateAndTime(
                                                rowItem.archivedDate
                                            )
                                        // this.parseDateExcelToUTC(
                                        // )
                                    }
                                </label>
                            ) : (
                                <label>{""}</label>
                            )}
                        </Column>
                        <Column size="3 doCenter">
                            <InlineRow>
                                {/* <Column size="6"> */}
                                {rowItem.archivedDate !== "" ? (
                                    <button
                                        className="btn btnLabel doCenter newFontMontserrat"
                                        id={
                                            "btn_archive_restore_item _" + index
                                        }
                                        onClick={() =>
                                            this.handleRestoreBtnClick(
                                                rowItem,
                                                index
                                            )
                                        }
                                        title="Restore"
                                    >
                                        RESTORE
                                    </button>
                                ) : (
                                    <label>{""}</label>
                                )}
                                {/* </Column> */}
                                {/* <Column size="6"> */}
                                {/* {rowItem.archivedDate !== "" ? (
                                        <button className="btn btnLabel doCenter newFontMontserrat">
                                            
                                            VIEW
                                        </button>
                                    ) : (
                                        <label>{""}</label>
                                    )} */}
                                {/* </Column> */}
                            </InlineRow>
                        </Column>
                    </InlineRow>
                );
            });
        return rowsForLogs;
    };
    render() {
        this.rowData = this.props.rowItems;
        return (
            <div className="archive_main_container">
                <div className="archive_header_container">
                    {this.renderHeaderBar()}
                </div>
                <div className="archive_main_data invisibleScroller">
                    <div className="archive_header">
                        {this.renderCardHeaderRow()}
                    </div>
                    <div className="archive_data_container invisibleScroller">
                        {this.renderCardRow()}
                    </div>
                    <div className="archive_pagination">
                        {this.renderPagination()}
                    </div>
                </div>
            </div>
        );
    }
}

export default ArchiveListItems;
